// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__3MfzK","modal":"Modal_modal__YwX8Y","slide-down":"Modal_slide-down__t1U3e"};